import { IWarehouseShelf } from "../../../../interfaces/delivery-company/warehouseshelf";

export const emptyShelf: IWarehouseShelf = {
    id: "",
    label: "",
    orders: []
}